/**
 * Constantes y configuración para el módulo de Sucursales
 */

// ==========================================
// ESTADOS DE MÉXICO
// ==========================================
export const ESTADOS_MEXICO = [
  "Aguascalientes",
  "Baja California",
  "Baja California Sur",
  "Campeche",
  "Chiapas",
  "Chihuahua",
  "Ciudad de México",
  "Coahuila de Zaragoza",
  "Colima",
  "Durango",
  "Guanajuato",
  "Guerrero",
  "Hidalgo",
  "Jalisco",
  "México",
  "Michoacán de Ocampo",
  "Morelos",
  "Nayarit",
  "Nuevo León",
  "Oaxaca",
  "Puebla",
  "Querétaro",
  "Quintana Roo",
  "San Luis Potosí",
  "Sinaloa",
  "Sonora",
  "Tabasco",
  "Tamaulipas",
  "Tlaxcala",
  "Veracruz de Ignacio de la Llave",
  "Yucatán",
  "Zacatecas",
];

// ==========================================
// OPCIONES DE CANTIDAD PARA EQUIPOS
// ==========================================
export const CANTIDAD_OPCIONES = [
  { value: "no_aplica", label: "No aplica" },
  { value: "0", label: "0" },
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
  { value: "5", label: "5" },
  { value: "6", label: "6" },
  { value: "7", label: "7" },
  { value: "8", label: "8" },
  { value: "9", label: "9" },
  { value: "10", label: "10" },
  { value: "11", label: "11" },
  { value: "12", label: "12" },
  { value: "13", label: "13" },
  { value: "14", label: "14" },
  { value: "15", label: "15" },
  { value: "16", label: "16" },
  { value: "17", label: "17" },
  { value: "18", label: "18" },
  { value: "19", label: "19" },
  { value: "20", label: "20" },
  { value: "25", label: "25" },
  { value: "30", label: "30" },
  { value: "35", label: "35" },
  { value: "40", label: "40" },
  { value: "45", label: "45" },
  { value: "50", label: "50" },
  { value: "50+", label: "50+" },
];

// ==========================================
// CAMPOS DE FORMULARIO
// ==========================================

/**
 * Campos para crear una nueva sucursal
 */
export const getBranchFormFields = (clientes) => [
  {
    name: "client",
    label: "Cliente",
    type: "select",
    options: clientes.map((c) => ({ value: c._id, label: c.name })),
    required: true,
  },
  {
    name: "name",
    label: "Nombre de la sucursal",
    required: true,
  },
  {
    name: "city",
    label: "Zona / Estado",
    type: "select",
    allowNone: true,
    options: ESTADOS_MEXICO.map((estado) => ({
      value: estado,
      label: estado,
    })),
  },
  {
    name: "address",
    label: "Dirección completa",
  },
  {
    name: "closingHour",
    label: "Hora de cierre",
    type: "time",
  },
  {
    name: "contactName",
    label: "Nombre del contacto",
    placeholder: "Opcional",
  },
  {
    name: "contactEmail",
    label: "Email del contacto",
    type: "email",
    placeholder: "Opcional",
  },
  {
    name: "contactPhone",
    label: "Teléfono del contacto",
    type: "tel",
    placeholder: "Opcional",
  },
  {
    name: "cebaderosRodenticida",
    label: "Cebaderos con rodenticida",
    type: "select",
    options: CANTIDAD_OPCIONES,
    compact: true,
  },
  {
    name: "trampasMulticaptura",
    label: "Trampas Multicaptura",
    type: "select",
    options: CANTIDAD_OPCIONES,
    compact: true,
  },
  {
    name: "equiposMonitoreoUV",
    label: "Equipos de monitoreo UV",
    type: "select",
    options: CANTIDAD_OPCIONES,
    compact: true,
  },
  {
    name: "dispensadoresPiretrinas",
    label: "Dispensadores de piretrinas",
    type: "select",
    options: CANTIDAD_OPCIONES,
    compact: true,
  },
];

/**
 * Campos para editar una sucursal existente
 */
export const getBranchEditFields = (clientes) => [
  {
    name: "client",
    label: "Cliente",
    type: "select",
    options: clientes.map((c) => ({ value: c._id, label: c.name })),
    disabled: true, // El cliente no es editable
  },
  {
    name: "name",
    label: "Nombre de la sucursal",
    required: true,
  },
  {
    name: "city",
    label: "Zona / Estado",
    type: "select",
    allowNone: true,
    options: ESTADOS_MEXICO.map((estado) => ({
      value: estado,
      label: estado,
    })),
  },
  {
    name: "address",
    label: "Dirección completa",
  },
  {
    name: "closingHour",
    label: "Hora de cierre",
    type: "time",
  },
  {
    name: "contactName",
    label: "Nombre del contacto",
    placeholder: "Opcional",
  },
  {
    name: "contactEmail",
    label: "Email del contacto",
    type: "email",
    placeholder: "Opcional",
  },
  {
    name: "contactPhone",
    label: "Teléfono del contacto",
    type: "tel",
    placeholder: "Opcional",
  },
  {
    name: "cebaderosRodenticida",
    label: "Cebaderos con rodenticida",
    type: "select",
    options: CANTIDAD_OPCIONES,
    compact: true,
  },
  {
    name: "trampasMulticaptura",
    label: "Trampas Multicaptura",
    type: "select",
    options: CANTIDAD_OPCIONES,
    compact: true,
  },
  {
    name: "equiposMonitoreoUV",
    label: "Equipos de monitoreo UV",
    type: "select",
    options: CANTIDAD_OPCIONES,
    compact: true,
  },
  {
    name: "dispensadoresPiretrinas",
    label: "Dispensadores de piretrinas",
    type: "select",
    options: CANTIDAD_OPCIONES,
    compact: true,
  },
];

// ==========================================
// CONFIGURACIÓN DE TEMA
// ==========================================
export const BRANCHES_THEME = {
  colors: {
    primary: "#1976d2",
    primaryLight: "#42a5f5",
    primaryDark: "#115293",
    secondary: "#0288d1",
    success: "#4caf50",
    warning: "#ff9800",
    error: "#f44336",
    cardBackground: "#ffffff",
    clientCardBg: "#f8f9fa",
    branchCardBg: "#ffffff",
    hoverBg: "#f5f5f5",
  },
  spacing: {
    cardPadding: 2,
    sectionGap: 3,
    itemGap: 1.5,
  },
  borderRadius: {
    card: 3,
    button: 2,
    chip: 2,
  },
};

// ==========================================
// CONFIGURACIÓN DE ANIMACIONES
// ==========================================
export const ANIMATION_CONFIG = {
  transition: "all 0.3s ease",
  hoverScale: 1.02,
  cardShadow: "0 4px 12px rgba(0,0,0,0.08)",
  cardShadowHover: "0 8px 24px rgba(0,0,0,0.12)",
};

// ==========================================
// TEXTOS Y MENSAJES
// ==========================================
export const MESSAGES = {
  deleteConfirm: (branchName) =>
    `¿Estás seguro de que deseas eliminar la sucursal "${branchName}"? Esta acción no se puede deshacer.`,
  noResults: "No se encontraron sucursales con los filtros aplicados",
  loading: "Cargando sucursales...",
  error: "Error al cargar los datos",
  emptyState: "No hay sucursales registradas",
  emptyStateAction: "Crea tu primera sucursal",
};

// ==========================================
// VISTA DE MODOS
// ==========================================
export const VIEW_MODES = {
  GRID: "grid",
  LIST: "list",
};

